<nav mat-tab-nav-bar>
  <a mat-tab-link [active]="activeMenuItem == 'companies'" routerLink="/companies"> Companies </a>
  <a mat-tab-link [active]="activeMenuItem == 'products'" routerLink="/products"> Products </a>
</nav>
